import "./PaymentProofs.scss";
import Phone from '../../images/user/phone.png';
import Email from '../../images/user/mail.png';

function PaymentProofCard(proof) {
    return (
        <div className="payment">
            <div className="shapes"><div className="top"></div><div className="bottom"></div><div className="bottom medium"></div></div>
            <div className="payment-wrp">
                <div className="account-holder">
                    <div className="title">ACCOUNT HOLDER</div>
                    <div className="profile">
                        <img className="profile-img" src={proof?.profilePic} alt="profile-img" />
                        <div className="name">{proof?.name}</div>
                    </div>
                </div>
                <div className="contacts">
                    <div className="type">
                        <div className="icon">
                            <img className="email" src={Email} alt="email" />
                        </div>
                        <div className="text">{proof?.email}</div>
                    </div>
                    <div className="type">
                        <div className="icon">
                            <img className="phone" src={Phone} alt="phone" />
                        </div>
                        <div className="text">{proof?.phone}</div>
                    </div>
                </div>
                <div className="received">
                    <div className="title">PAYMENT RECEIVED</div>
                    <div className="amount">{proof?.amount}</div>
                </div>
            </div>
        </div>
    );
}

export default PaymentProofCard;
